module.exports = __webpack_public_path__ + "img/set_theme_15.90b2c543.png";